import { Payload } from '@smile-next/uikit';
import { ErrorBase } from '@/errors/ErrorBase';
import { AuthParams } from '@/models/domain/AuthParams';

type AuthenticatedFailurePayloadArgs = {
    authParams: AuthParams;
    error: ErrorBase;
    isDisplayedCloudId?: boolean;
};

export class AuthenticatedFailurePayload extends Payload {
    type = 'AuthenticatedFailurePayload';

    constructor(readonly authenticatedFailurePayloadArgs: AuthenticatedFailurePayloadArgs) {
        super();
    }
}
